export default "__VITE_ASSET__DauH0piZ__"